import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { TextInput } from "shared/ui/input/text/TextInput"

export interface PortalNewsSearchInputProps extends WithClassName {
  loading?: boolean
  disabled?: boolean
}

export const PortalNewsSearchInput = React.memo(
  ({ loading, disabled, className }: PortalNewsSearchInputProps) => {
    const { t } = useTranslation()

    return (
      <TextInput.Root
        name="searchTerm"
        label={t("General.Search")}
        loading={loading}
        disabled={disabled}
        className={classNames("portal-news-page__search", className)}
      >
        <TextInput.Label />
        <TextInput.Focus>
          <TextInput.Input />
          <TextInput.Clear />
          <TextInput.Affix>
            <Icon name={IconName.SEARCH} />
          </TextInput.Affix>
        </TextInput.Focus>
      </TextInput.Root>
    )
  }
)

PortalNewsSearchInput.displayName = "PortalNewsSearchInput"
